export default __webpack_public_path__ + "static/media/bannersection.3f83fc24.jpg";